import { logBase } from '@game-libs/exc-libs';

export const costToBuyNItems = (
  initialCost: number,
  growthRate: number,
  currentOwned: number,
  numberToBuy: number
): number => {
  if (growthRate === 1) {
    // No cost growth, flat pricing
    return initialCost * numberToBuy;
  }

  const cost =
    (initialCost *
      Math.pow(growthRate, currentOwned) *
      (1 - Math.pow(growthRate, numberToBuy))) /
    (1 - growthRate);

  return cost;
};

export const maxPurchasableItems = (
  gold: number,
  initialCost: number,
  growthRate: number,
  itemsAlreadyBought: number
): number => {
  if (growthRate === 1) {
    // Linear cost
    const costPerItem = initialCost;
    return Math.floor(gold / costPerItem);
  }

  const currentMultiplier = Math.pow(growthRate, itemsAlreadyBought);
  const ratio =
    1 - (gold / (initialCost * currentMultiplier)) * (1 - growthRate);

  if (ratio <= 0) {
    return Infinity; // You can afford infinite items (or many)
  }

  return Math.floor(logBase(ratio, growthRate));
};
